const AppFooter = () => {
  return (
    <footer className="sticky-footer">
      <small className="copyright me-auto ps-3">Links Management and Technology Copyright © 2025</small>
    </footer>
  );
};
export default AppFooter;
